/* eslint-disable */
import React, { useEffect, Suspense } from 'react'

// Import YapContentBuilder components
import { YapContentBuilder, 
         YapContentValidations, 
         YapContentPreviewsModal,
         YapContentPreview,
         YapPage, 
         YapHeader,
         YapHeaderButton,
         YapNotification,
         YapAssetType,
         useYapPageState,
         YapUIGenerator,
         DocumentYapUI
       } from '@yapstudios/yap-content-builder'

// Auth / loading
import { AuthProvider } from "./useAuth.js"
import { ProtectedRoute } from "./ProtectedRoute.js"
import { Loading } from "./Loading.js"

// React router
import { useNavigate, useLoaderData, Link, useParams, Await } from "react-router-dom";

// Configuration
import { getConfiguration } from './ContentConfiguration.js'

// Data model methods
import { initBucketData, currentInstanceId, fileUploader, loadAssets, deleteAsset, updateAsset, updateDocument, loadDocument } from './AppData.js'

// CSS
import '@yapstudios/yap-content-builder/dist/index.css'

/**
* Loader
*/
export const ContentBuilderAuthLoader = (props) => {
    const { userPromise } = useLoaderData();
    const params = useParams();
    console.log('ContentBuilderAuthLoader')
    
    return (
        <AuthProvider>
            <ProtectedRoute>
                <Suspense fallback={<Loading/>}>
                    <Await
                        resolve={userPromise({params: params})}
                        children={(data) => (
                            <ContentBuilder document={data}/>
                        )}
                    />
                </Suspense>
            </ProtectedRoute>
        </AuthProvider>
    );
};

async function contentLoader({ params }) {
    // Initialise info from user 
    initBucketData()
    const document = await loadDocument(params.documentId);
    return document
}

const ContentBuilder = ({ document }) => {
    const { documentId } = useParams();
    const navigate = useNavigate()

    const [pages, setPages] = React.useState(document ? document.pages : null)
    const [yapuiJSON, setYapUIJSON] = React.useState(null)
    const [assets, setAssets] = React.useState({})
    const [showPreview, setShowPreview] = React.useState(false)
    const [showSidebar, setShowSidebar] = React.useState(false)
    const [showDebug, setShowDebug] = React.useState(false)
    const [selectedPageId, setSelectedPageId] = React.useState(null)

    const [ showPublishNotification, setShowPublishNotification ] = React.useState(false);
    
    const pagesRef = React.useRef()
    pagesRef.current = pages

   
    const bucketData = initBucketData()

    useEffect(() => {
        loadAssets('test').then(
            (value) => {
                setAssets(value)
            },
            (error) => {
                console.log(error)
            }
        )
    }, [])

    useEffect(() => {
        if (yapuiJSON == null) {
            if (document && document.yapuijson ) {
                setYapUIJSON(JSON.parse(document.yapuijson))
            }
        }
    }, [yapuiJSON])

    const  { components, componentTemplates, templateLibrary, validations, fonts, styles, pageRenderer, previewRenderer, pageTitle, multiplePages, canInsertComponent } = getConfiguration(currentInstanceId())

    // const onSetYapUI = (yapui, documentContent, declarationContent) => {
    //     setYapUI(yapui)
    // }

    const onSetPages = (pages) => {

        if (pageTitle) {
            pages = pages.map( (page, index) => {
                page.title = pageTitle(page, index, pages)
                return page
            })
            //pages[0].title = pageTitle(pages[0])
        } else {
            // Update title
            var titleSection = pages[0].sections[0]

            if (titleSection) {
                pages[0].title = titleSection.props.title
            }
        }

        console.log('onSetPages')
        console.log(JSON.stringify(pages))

        pagesRef.current = pages
        setPages(pages)
    }


    // onAssetImport callback
    // YapContentBuilder passes in the follow parameters 
    //
    // - file: HTML File object that represents the file selected by the user
    // - asset: Suggested dictionary for convenience to represent the asset object. Will contain id, type, title, dimensions.
    // - album: Album the user is currently in 
    // - progressCallback: Callback to call when upload progress changes. progressCallback(percentComplete);
    // - completeCallback: Callback to call when upload is complete. completeCallback(newAsset, error)
    //
    // Return value:
    //   Function to call that will be called if the upload is cancelled by the user
    //
    const onImport = (file, asset, album, progressCallback, completeCallback, errorCallback) => {
        
        // In this example app we're adding the album name to the asset itself.
        // This is just an implementation detail of this example.
        var asset = asset 
        asset.album = album.name

        const uploadTask = fileUploader({
            file: file,
            asset: asset,
            progressCallback: progressCallback,
            completeCallback: completeCallback,
            errorCallback: errorCallback,
            setAssets: setAssets
        })

        // Return value to onAssetImport is a function that will be called if the upload is cancelled by the user
        return () => {
            uploadTask.cancel()
        }
    }

    // onAssetDeleteCallback callback
    // Called when an asset is deleted
    //
    // Passes the following parameters
    // - asset: Asset dictionary represeting the object
    const onAssetDelete = (asset) => {
        setAssets({...deleteAsset(asset, "test")})
    }

    // onAssetChangeCallback callback
    // Called when an asset's properties are updated by the user.
    //
    // Passes the following parameters
    // - asset: Asset dictionary represeting the object
    const onAssetChange = (asset) => {
        setAssets({...updateAsset(asset, "test")})
    }

    const onDone = (validationPassed) => {

        let freshUI =  new DocumentYapUI().update(pagesRef.current, components, pageRenderer);

        let title = pageTitle ?? (pagesRef.current ? pagesRef.current[0].title : null)

        if (validationPassed) {
            updateDocument(documentId ?? "unknown", { pages: pagesRef.current, yapui: [], title: title, yapuijson: JSON.stringify(freshUI)  })

            setShowPublishNotification(true)
        } else {
            console.log('Validation Failed')
        }
    }

    const actions = [
        <YapHeaderButton key="options" onClick={() => {
            setShowDebug(!showDebug)
        }}>{"Options"}</YapHeaderButton>,

        <YapHeaderButton key="preview" onClick={() => {
            setShowPreview(true)
        }}>{"Preview"}</YapHeaderButton>

    ]

    const sidebarButton = (
        <YapHeaderButton key="sidebar" onClick={() => {
            setShowSidebar(!showSidebar)
        }}>
            <div>
                <svg width="23" height="22" viewBox="0 -2 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M3.51074 18.0596C2.48405 18.0596 1.70166 17.7936 1.16357 17.2617C0.631673 16.736 0.365723 15.966 0.365723 14.9517V3.67969C0.365723 2.66536 0.631673 1.89535 1.16357 1.36963C1.70166 0.837728 2.48405 0.571777 3.51074 0.571777H19.2729C20.2996 0.571777 21.0789 0.837728 21.6108 1.36963C22.1427 1.89535 22.4087 2.66536 22.4087 3.67969V14.9517C22.4087 15.966 22.1427 16.736 21.6108 17.2617C21.0789 17.7936 20.2996 18.0596 19.2729 18.0596H3.51074ZM3.67773 16H19.0967C19.4987 16 19.8079 15.8979 20.0244 15.6938C20.2409 15.4836 20.3491 15.165 20.3491 14.7383V3.89307C20.3491 3.46631 20.2409 3.15088 20.0244 2.94678C19.8079 2.73649 19.4987 2.63135 19.0967 2.63135H3.67773C3.26953 2.63135 2.95719 2.73649 2.74072 2.94678C2.53044 3.15088 2.42529 3.46631 2.42529 3.89307V14.7383C2.42529 15.165 2.53044 15.4836 2.74072 15.6938C2.95719 15.8979 3.26953 16 3.67773 16ZM7.97314 16.2969V2.29736H9.90283V16.2969H7.97314ZM6.12695 5.98975H4.28076C4.1014 5.98975 3.94678 5.9248 3.81689 5.79492C3.68701 5.66504 3.62207 5.5166 3.62207 5.34961C3.62207 5.17643 3.68701 5.0249 3.81689 4.89502C3.94678 4.76514 4.1014 4.7002 4.28076 4.7002H6.12695C6.30632 4.7002 6.46094 4.76514 6.59082 4.89502C6.72689 5.0249 6.79492 5.17643 6.79492 5.34961C6.79492 5.5166 6.72689 5.66504 6.59082 5.79492C6.46094 5.9248 6.30632 5.98975 6.12695 5.98975ZM6.12695 8.54102H4.28076C4.1014 8.54102 3.94678 8.47607 3.81689 8.34619C3.68701 8.21631 3.62207 8.06478 3.62207 7.8916C3.62207 7.71842 3.68701 7.56999 3.81689 7.44629C3.94678 7.31641 4.1014 7.25146 4.28076 7.25146H6.12695C6.30632 7.25146 6.46094 7.31641 6.59082 7.44629C6.72689 7.56999 6.79492 7.71842 6.79492 7.8916C6.79492 8.06478 6.72689 8.21631 6.59082 8.34619C6.46094 8.47607 6.30632 8.54102 6.12695 8.54102ZM6.12695 11.083H4.28076C4.1014 11.083 3.94678 11.0212 3.81689 10.8975C3.68701 10.7676 3.62207 10.616 3.62207 10.4429C3.62207 10.2697 3.68701 10.1213 3.81689 9.99756C3.94678 9.86768 4.1014 9.80273 4.28076 9.80273H6.12695C6.30632 9.80273 6.46094 9.86768 6.59082 9.99756C6.72689 10.1213 6.79492 10.2697 6.79492 10.4429C6.79492 10.616 6.72689 10.7676 6.59082 10.8975C6.46094 11.0212 6.30632 11.083 6.12695 11.083Z" fill="#374DC0"/>
                </svg>
            </div>
        </YapHeaderButton>
    )

    // Header actions
    let leftActions = multiplePages ? [sidebarButton] : []

    // Back / cancel action
    const onBack = () => {
        navigate("/")
    }

    let assetLibraryData = []
    for (const assetKey in assets) {
        const asset = assets[assetKey];
        assetLibraryData.push(asset)
    }

    // Use title from the current page
    const title = (pages && pages[0]) ? pages[0].title : '' 

    let defaultTemplate = null//new BasicMessageTemplate()

    const canAddAssetType = (assetType) => {
        if (assetType == YapAssetType.Model && bucketData.canImportModels == false) {
            return false
        } else {
            return true
        }
    }

    let selectedPage = (pages ? pages.filter( page => page.id == selectedPageId)[0] : null)
    
    return (
            <YapPage>
                <YapHeader backTitle={"Back"} onBack={onBack} fixed={true} headerActions={actions} headerActionsLeft={leftActions}></YapHeader>                
                <YapNotification title="Published" icon={"success"} show={showPublishNotification} setShow={setShowPublishNotification}/>
                <YapContentBuilder components={components}  
                        componentTemplates={componentTemplates} 
                        pages={pages} 
                        onPagesUpdated={onSetPages} 
                        yapuiJSON={yapuiJSON}
                        onYapUIJSONUpdated={setYapUIJSON}
                        assets={assetLibraryData} 
                        defaultTemplate={defaultTemplate}
                        templates={templateLibrary} 
                        fonts={fonts}
                        styles={styles}
                        validations={validations}
                        canAddAssetType={canAddAssetType}
                        onAssetImport={onImport} 
                        onAssetChange={onAssetChange} 
                        onAssetDelete={onAssetDelete}
                        onDone={onDone} 
                        canInsertComponent={canInsertComponent}
                        showSidebar={showSidebar}
                        multiplePages={multiplePages}
                        pageRenderer={pageRenderer}
                        showDebug={showDebug}
                        onSelectedPageId={setSelectedPageId}
                        />

                <YapContentPreviewsModal show={showPreview} onClose={setShowPreview}>
                    <YapContentPreview name="Content Preview" styles={styles} fonts={fonts} components={components} document={document ?? { id: documentId, pages: [] }} page={selectedPage ? selectedPage : null} pageRenderer={pageRenderer} renderer={previewRenderer} />
                </YapContentPreviewsModal>

            </YapPage>
    )
}

export { ContentBuilder, contentLoader }
